import type { ReactNode } from "react";

interface SectionHeadingProps {
  kicker: string;
  title: ReactNode;
  desc?: string;
  action?: ReactNode;
  align?: "left" | "center";
}

export default function SectionHeading({
  kicker,
  title,
  desc,
  action,
  align = "left",
}: SectionHeadingProps) {
  const centered = align === "center";
  return (
    <div
      className={`flex flex-col gap-5 ${
        centered ? "items-center text-center" : "md:flex-row md:items-end md:justify-between"
      }`}
    >
      <div className={centered ? "max-w-2xl" : "max-w-2xl"}>
        <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.24em] uppercase text-primary-700">
          <span className="w-6 h-px bg-primary-400"></span>
          {kicker}
        </span>
        <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
          {title}
        </h2>
        {desc && <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}